/* ============================================
   SHARED.JS — Nymphai Shared Components
   Preloader, Lenis, Burger Menu, Cursor, Nav
   ============================================
   Included on all pages BEFORE page-specific JS.
   Uses var for broad compatibility.
   All sections wrapped in IIFEs with null guards.
   ============================================ */


/* ---------- 1. GSAP PLUGIN REGISTRATION ---------- */
gsap.registerPlugin(ScrollTrigger);
if (typeof Flip !== 'undefined') gsap.registerPlugin(Flip);


/* ---------- 2. PRELOADER ---------- */
(function () {
  var preloader = document.getElementById('preloader');
  if (!preloader) {
    // Nessun preloader nel DOM: spara preloader-done nella prossima macrotask
    // (setTimeout garantisce che tutti gli script defer abbiano registrato i listener)
    setTimeout(function () {
      window.dispatchEvent(new CustomEvent('preloader-done'));
    }, 0);
    return;
  }

  document.body.style.overflow = 'hidden';

  function dismissPreloader() {
    gsap.to(preloader, {
      opacity: 0,
      duration: 0.5,
      ease: 'power2.inOut',
      onComplete: function () {
        preloader.remove();
        document.body.style.overflow = '';
        ScrollTrigger.refresh();
        window.dispatchEvent(new CustomEvent('preloader-done'));
      },
    });
  }

  setTimeout(dismissPreloader, 500);
})();


/* ---------- 3. LENIS SMOOTH SCROLL ---------- */
(function () {
  var isDettProdotto = document.querySelector('.page-dett-prodotto');

  var config = {
    easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
    orientation: 'vertical',
    smoothWheel: true,
  };

  if (isDettProdotto) {
    config.duration = 1.8;
    config.lerp = 0.05;
    config.gestureOrientation = 'vertical';
    config.wheelMultiplier = 0.9;
    config.touchMultiplier = 2;
  } else {
    config.duration = 1.2;
  }

  var lenis = new Lenis(config);

  // Sync Lenis with GSAP ScrollTrigger
  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add(function (time) {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);

  // Expose globally so page-specific JS can call lenis.stop() / lenis.start()
  window.lenis = lenis;
})();


/* ---------- 4. BURGER MENU ---------- */
(function () {
  var burger = document.getElementById('dett-burger');
  var overlay = document.getElementById('dett-menu-overlay');
  if (!burger || !overlay) return;

  var bg = overlay.querySelector('.dett-menu-overlay__bg');
  var links = overlay.querySelectorAll('.dett-menu-overlay__link');
  var subLinks = Array.from(overlay.querySelectorAll('.overlay-sub__link, .overlay-sub__linea'));
  var social = overlay.querySelector('.dett-menu-overlay__bottom');
  var menuImage = overlay.querySelector('.dett-menu-overlay__image');
  var bars = burger.querySelectorAll('.dett-burger__bar');
  var isOpen = false;

  // Nascondi sublink fin da subito — .to() in timeline cattura questa posizione
  if (subLinks.length) gsap.set(subLinks, { clipPath: 'inset(100% 0 0 0)', opacity: 0, y: 30 });

  var tl = gsap.timeline({
    paused: true,
    defaults: { ease: 'power3.out' },
    onReverseComplete: function () {
      overlay.classList.remove('is-open');
      burger.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('inert', '');
      burger.setAttribute('aria-expanded', 'false');
    }
  });

  var circleOrigin = '40px 40px';

  tl
    .to(bg, {
      clipPath: 'circle(150% at ' + circleOrigin + ')',
      duration: 0.9,
      ease: 'power3.inOut'
    })
    .to(bars[0], { rotation: 45, y: 3.75, duration: 0.4, ease: 'power2.inOut' }, 0)
    .to(bars[1], { rotation: -45, y: -3.75, duration: 0.4, ease: 'power2.inOut' }, 0)
    .fromTo(links, {
      clipPath: 'inset(100% 0 0 0)', opacity: 0, y: 30
    }, {
      clipPath: 'inset(0% 0 0 0)', opacity: 1, y: 0,
      duration: 0.6, stagger: 0.07, ease: 'power2.out'
    }, 0.35)
    .fromTo(social, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' }, 0.7)
  if (menuImage) tl.fromTo(menuImage, { opacity: 0, scale: 0.9 }, { opacity: 1, scale: 1, duration: 0.6, ease: 'power2.out' }, 0.5);
  if (subLinks.length) tl.to(subLinks, { clipPath: 'inset(0% 0 0 0)', opacity: 1, y: 0, duration: 0.6, stagger: 0.07, ease: 'power2.out' }, 0.49);

  function openMenu() {
    isOpen = true;
    overlay.classList.add('is-open');
    burger.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.removeAttribute('inert');
    burger.setAttribute('aria-expanded', 'true');
    window.lenis.stop();
    if (subLinks.length) gsap.set(subLinks, { clipPath: 'inset(100% 0 0 0)', opacity: 0, y: 30 });
    tl.timeScale(1).play();
  }

  function closeMenu() {
    isOpen = false;
    burger.classList.remove('is-open');
    window.lenis.start();
    tl.timeScale(1.2).reverse();
  }

  burger.addEventListener('click', function () {
    isOpen ? closeMenu() : openMenu();
  });

  links.forEach(function (link) {
    link.addEventListener('click', function () {
      if (isOpen) closeMenu();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeMenu();
  });
})();


/* ---------- 5. CUSTOM CURSOR — Dot + Ring ---------- */
(function () {
  var cursorEl = document.getElementById('cursor');
  if (!cursorEl) return;
  if ('ontouchstart' in window && !window.matchMedia('(pointer: fine)').matches) return;

  var ring = cursorEl.querySelector('.Cursor__ring');
  var dot  = cursorEl.querySelector('.Cursor__dot');
  if (!ring || !dot) return;

  var mouseX = window.innerWidth  / 2;
  var mouseY = window.innerHeight / 2;
  var ringX  = mouseX;
  var ringY  = mouseY;

  window.addEventListener('mousemove', function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    dot.style.transform = 'translate3d(' + mouseX + 'px,' + mouseY + 'px,0) translate(-50%,-50%)';
  });

  (function tick() {
    ringX += (mouseX - ringX) * 0.10;
    ringY += (mouseY - ringY) * 0.10;
    ring.style.transform = 'translate3d(' + ringX + 'px,' + ringY + 'px,0) translate(-50%,-50%)';
    requestAnimationFrame(tick);
  })();

  var hoverState = 'default';

  function setCursorState(state) {
    if (hoverState === state) return;
    hoverState = state;
    cursorEl.classList.remove('Cursor--image', 'Cursor--link');
    if (state === 'link')  cursorEl.classList.add('Cursor--link');
    if (state === 'image') cursorEl.classList.add('Cursor--image');
  }

  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (t.closest('a, button, [role="button"]')) {
      setCursorState('link');
    } else if (t.closest('img, video, svg image, .dett-filter-img, .dett-filter-video')) {
      setCursorState('image');
    } else {
      setCursorState('default');
    }
  });
})();


/* ---------- 5b. PRODOTTI CURSOR — rotating EXPLORE ring ---------- */
(function () {
  var overlays = document.querySelectorAll('#prodotti .prodotti__img-overlay');
  if (!overlays.length) return;
  if ('ontouchstart' in window && !window.matchMedia('(pointer: fine)').matches) return;

  // Build element dynamically — no HTML changes needed per page
  var el = document.createElement('div');
  el.id = 'prodotti-cursor';
  el.setAttribute('aria-hidden', 'true');
  el.innerHTML =
    '<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg">' +
    '<defs><path id="prd-c-path" d="M65,65 m-52,0 a52,52 0 1,1 104,0 a52,52 0 1,1 -104,0"/></defs>' +
    '<text><textPath href="#prd-c-path">EXPLORE \u2022 EXPLORE \u2022 EXPLORE \u2022\u00A0</textPath></text>' +
    '</svg>' +
    '<svg class="prodotti-cursor__arrow" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<line x1="1.5" y1="11.5" x2="11.5" y2="1.5" stroke="#ffebcf" stroke-width="1.4" stroke-linecap="round"/>' +
    '<path d="M5.5 1.5 H11.5 V7.5" stroke="#ffebcf" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
  document.body.appendChild(el);

  var cursorEl = document.getElementById('cursor');

  // Position follows mouse exactly (no lag — the ring lag would fight the scale animation)
  window.addEventListener('mousemove', function (e) {
    el.style.left = e.clientX + 'px';
    el.style.top  = e.clientY + 'px';
  }, { passive: true });

  overlays.forEach(function (overlay) {
    overlay.addEventListener('mouseenter', function () {
      el.classList.add('is-visible');
      if (cursorEl) cursorEl.classList.add('Cursor--prodotti');
    });
    overlay.addEventListener('mouseleave', function () {
      el.classList.remove('is-visible');
      if (cursorEl) cursorEl.classList.remove('Cursor--prodotti');
    });
  });
})();


/* ---------- 6. NAV SCROLL DETECTION ---------- */
(function () {
  var nav = document.querySelector('.dett-nav');
  if (!nav) return;

  ScrollTrigger.create({
    start: 'top -80',
    end: 99999,
    onUpdate: function (self) {
      if (self.direction === 1 && self.progress > 0) {
        nav.classList.add('is-scrolled');
      } else if (self.progress === 0) {
        nav.classList.remove('is-scrolled');
      }
    }
  });

  /* Hide nav on scroll down at ≤1280px */
  window.lenis.on('scroll', function (e) {
    if (window.innerWidth > 1280) return;
    if (e.scroll < 80) {
      nav.classList.remove('dett-nav--hidden');
      return;
    }
    if (e.direction === 1) {
      nav.classList.add('dett-nav--hidden');
    } else if (e.direction === -1) {
      nav.classList.remove('dett-nav--hidden');
    }
  });
})();


/* ============================================
   LANGUAGE MENU DROPDOWN (tablet/mobile)
   ============================================ */

(function() {
  document.querySelectorAll('.lang-menu').forEach(function(menu) {
    var active = menu.querySelector('.lang-menu__active');
    if (!active) return;

    active.addEventListener('click', function(e) {
      e.stopPropagation();
      menu.classList.toggle('is-open');
    });
  });

  document.addEventListener('click', function() {
    document.querySelectorAll('.lang-menu.is-open').forEach(function(m) {
      m.classList.remove('is-open');
    });
  });
})();

/* ============================================
   LANGUAGE SWITCHER TRANSITION
   ============================================ */

(function() {
  var overlay = document.createElement('div');
  overlay.className = 'lang-overlay';
  document.body.appendChild(overlay);

  if (sessionStorage.getItem('lang_transitioning')) {
    sessionStorage.removeItem('lang_transitioning');
    overlay.style.opacity = '1';
    overlay.style.transition = 'none';
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        overlay.style.transition = 'opacity 0.55s cubic-bezier(0.4, 0, 0.2, 1)';
        overlay.style.opacity = '0';
      });
    });
  }

  document.querySelectorAll('.lang-menu__option, .lang-btn:not(.is-active)').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      sessionStorage.setItem('lang_transitioning', '1');
      overlay.classList.add('fade-in');
      var form = btn.closest('form');
      var hidden = form.querySelector('input[name="locale_code"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'locale_code';
        form.appendChild(hidden);
      }
      hidden.value = btn.value;
      setTimeout(function() { form.submit(); }, 380);
    });
  });
})();

/* ============================================
   NAV IS-ON-FOOTER — altre pagine
   ============================================ */
(function () {
  var nav = document.querySelector('.dett-nav');
  var bottom = document.querySelector('.dett-hero__bottom');
  var footer = document.querySelector('.footer');
  if (!nav || !footer) return;
  function addDark()    { nav.classList.add('is-on-footer');    if (bottom) bottom.classList.add('is-on-footer'); }
  function removeDark() { nav.classList.remove('is-on-footer'); if (bottom) bottom.classList.remove('is-on-footer'); }
  ScrollTrigger.create({
    trigger: footer,
    start: 'top bottom',
    end: 'bottom top',
    onEnter:     addDark,
    onLeaveBack: removeDark,
    onLeave:     removeDark,
  });
})();

/* ============================================
   COOKIE BANNER ANIMATION — altre pagine
   ============================================ */
(function () {
  function showBanner(banner) {
    gsap.fromTo(banner,
      { opacity: 0, y: 18 },
      { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out', clearProps: 'transform' }
    );
  }

  function waitForBanner(onFound) {
    var el = document.querySelector('.shopify-pc__banner__dialog');
    if (el) { gsap.set(el, { opacity: 0 }); onFound(el); return; }
    var obs = new MutationObserver(function (_, observer) {
      el = document.querySelector('.shopify-pc__banner__dialog');
      if (el) { observer.disconnect(); gsap.set(el, { opacity: 0 }); onFound(el); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  waitForBanner(function (banner) {
    setTimeout(function () { showBanner(banner); }, 1500);
  });
})();
